
  import ipxRuntime$YDcmLpXEKDeekpVvkOth39wAh4o_45el_9r9mAqgVlNQ8 from '/app/node_modules/.pnpm/@nuxt+image@2.0.0_db0@0.3.4_@libsql+client@0.17.3_drizzle-orm@0.45.2_@libsql+client@0.1_35f1756999cd4336bc726353f2624b8c/node_modules/@nuxt/image/dist/runtime/providers/ipx'
  
  export const imageOptions = {
    ...{
  "screens": {
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp",
    "avif",
    "jpeg",
    "jpg",
    "png",
    "webp"
  ]
},
    /** @type {"ipx"} */
    provider: "ipx",
    providers: {
        ['ipx']: { setup: ipxRuntime$YDcmLpXEKDeekpVvkOth39wAh4o_45el_9r9mAqgVlNQ8, defaults: {"sharpOptions":{"autoOrient":true}} }
    }
  }
